import apiClient from './api';

export interface MeituanVerifyLog {
  id: string;
  callbackId: string;
  messageType: string;
  meituanOrderId: string;
  serviceOrderId: string;
  serviceOrderNo: string;
  shopId: string;
  opBizCode: string;
  developerId: string;
  businessId: string;
  verifyStatus: string;
  verifyChannel: string;
  type: string;
  serialNumber: string;
  processStatus: number;
  processMessage: string;
  rawPayload: string;
  createdAt: string;
  updatedAt: string;
}

export interface MeituanVerifyLogListParams {
  page?: number;
  pageSize?: number;
  meituanOrderId?: string;
  serviceOrderNo?: string;
  serialNumber?: string;
  verifyStatus?: string;
  processStatus?: string;
  startTime?: string;
  endTime?: string;
}

export const listMeituanVerifyLogs = (params: MeituanVerifyLogListParams) => (
  apiClient.get<{ list: MeituanVerifyLog[]; total: number; page: number; pageSize: number }>(
    '/meituan/verify-logs',
    { params },
  )
);
